import { memoize } from 'lodash';

/*
 * Verify that Investor ID is unique and alphanumeric,
 * also check if ID is not made just from Underscore and Hyphens
 */
import {
  isStringAlphaNumericUnderscoreHyphen,
  isStringOnlyUnderscoreHyphen
} from '../../core/utils';
import InvestorApi from '../../core/apis/InvestorApi';

// react admin
export function validateInvestorIdRa(value, _allValues, fieldProps) {
  let errors = {};
  if (fieldProps.active) {
    return validateInvestorId(value);
  }
  return errors.id;
}

// rff
export function validateInvestorIdRff(value) {
  return validateInvestorId(value);
}

export function isCountryWithState(value) {
  return countryWithState(value);
}

const countryWithState = country => {
  return country === 'CA' || country === 'US' || country === 'AU';
};

const validateInvestorId = memoize(async value => {
  const idValid = isStringAlphaNumericUnderscoreHyphen(value);
  const isValueOnlyUnderscoreHyphen = isStringOnlyUnderscoreHyphen(value);
  let error;

  if (!idValid) {
    error =
      'Investor ID must be unique and only contain numbers, letters, underscore and hyphen symbols without any spaces';
  } else if (!isValueOnlyUnderscoreHyphen) {
    error = 'Investor ID must contain at least one number or letter character';
  } else {
    try {
      const idExists = await InvestorApi.checkIdExists(value);
      if (idExists) {
        error = 'ID already exists';
      }
    } catch (e) {
      error = 'Cannot validate investor ID';
    }
  }
  return error;
});
